import React from 'react'

function TextDecodeHTML(props) {
  const { children, text = '', ...other } = props

  const nl2br = (str) => {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br/>')
  }
 
  return (
    <p {...other}>
      {' '}
      <span
        dangerouslySetInnerHTML={{
          __html: nl2br(text)
        }}
      ></span>
    </p>
  )
}

export default TextDecodeHTML
